// Where a task's or job's success/error numbers come from, as the backend
// states it (TaskSerializer.counters_source / stats.counters_source):
//  - "snapshot": the stored-log count, each roster row once;
//  - "progress": that count plus what the running bots have done since;
//  - "live": raw task counters, the scope has never been counted from its logs.
export type CountersSource = "live" | "snapshot" | "progress";

export function countersSource(raw: unknown): CountersSource {
  return raw === "snapshot" || raw === "progress" ? raw : "live";
}

export function countersTimeAgo(iso: string | null | undefined): string {
  if (!iso) return "";
  const ts = new Date(iso);
  if (Number.isNaN(ts.getTime())) return "";
  const min = Math.round((Date.now() - ts.getTime()) / 60000);
  const when =
    min < 1
      ? "just now"
      : min < 60
        ? `${min} min ago`
        : min < 60 * 24
          ? `${Math.round(min / 60)} h ago`
          : `${Math.round(min / (60 * 24))} d ago`;
  return `${when} (${ts.toLocaleString()})`;
}

/** The tooltip of a task's progress bar; the same words on the panel row and the task page. */
export function taskCountersTooltip(
  source: CountersSource,
  snapshotAt: string | null | undefined,
): string {
  const when = countersTimeAgo(snapshotAt);
  if (source === "snapshot") {
    return `Counted from the stored logs, each employee once, over the range this task covers now; an error a later run completed counts as a success.${when ? ` Refreshed ${when}.` : ""}`;
  }
  if (source === "progress") {
    return `Counted from the stored logs plus what this run has done since, each employee once; a retry that fails again changes nothing.${when ? ` Last stored count ${when}.` : ""}`;
  }
  return "Live task counters - this task has not been counted from its stored logs yet. The stored count appears when the job's queue drains or after Refresh.";
}
